<template>
    <div class="solution">
        <div class="title">SOLUTIONS</div>
        <div class="title">解决方案</div>
        <div class="card">
            <el-row>
                <el-col
                        v-for="(o, index) in solution_imgs"
                        :key="o"
                        :span="4"
                        :offset="index > 0 ? 2 : 1"
                >
                    <el-card :body-style="{ padding: '0px' }">
                        <img
                                :src="o.url"
                                class="image"
                        />
                        <div style="padding: 14px; font-size: 30px">
                            <div>{{ o.title }}</div>
                            <div class="bottom">
                                <div class="time">{{ o.context }}</div>
                                <div>
                                    <el-button type="primary" plain @click="handleClick(index)">了解详情</el-button>
                                </div>

                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
  name: "Solution",
  data() {
    return {
      solution_imgs: [
        {
          url: require("@/assets/images/v2_s3s9zy.jpg"),
          title: '智慧水质',
          context: '支持高光谱专业分析和大气校正导航，拥有光谱库、图像库、模型库和水质检测数据库管理模块，实时动态环境监测产品发布功能'
        },{
          url: require("@/assets/images/v2_s3safn.jpg"),
          title: '智慧土壤',
          context: '利用高-多光谱遥感技术实现土壤重金属污染定量监测与预警，提供大面积土壤重金属污染遥感定量空间动态监测服务'
        },{
          url: require("@/assets/images/v2_s3safz.jpg"),
          title: '智慧大气',
          context: '通过高光谱卫星遥感技术实现大气污染的实时精确监测，通过人工智能技术实时提供可能的污染风险预警和对应的防控措施'
        },{
          url: require("@/assets/images/v2_s3sagd.jpg"),
          title: '智慧生态',
          context: '基于面向双碳目标的碳汇监测技术，估测关键要素、影响要素及解决途径，实现主被动多源遥感协同的多尺度碳汇遥感监测技术系统'
        }
      ],
    };

  },
  methods: {
    handleClick(index) {
      if (index === 0) {
        this.$router.push('/solution-detail')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.solution {
  padding: 40px 0;
}
.title {
  text-align: left;
  margin-bottom: 10px;
  margin-left: 120px;
  font-size: 50px;
}
.sub-title {
  text-align: left;
  margin-bottom: 10px;
  margin-left: 120px;
  font-size: 40px;
}
.image {
  width: 100%;
  height: 130px;
  object-fit: cover;
  display: block;
}
.bottom {
  margin-top: 20px;
}
.card {
  margin-top: 40px;
}
.time {
  margin-bottom: 15px;
  font-size: 25px;
}
</style>